var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var MobileBlastAPI = /** @class */ (function (_super) {
    __extends(MobileBlastAPI, _super);
    function MobileBlastAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileBlastAPI.prototype.listRecipients = function (props) { return this.fetcher.get("/api/mobile-blast/recipients", props); };
    MobileBlastAPI.prototype.listHistory = function (props) { return this.fetcher.get("/api/mobile-blast/history", props); };
    MobileBlastAPI.prototype.send = function (props) { return this.fetcher.post("/api/mobile-blast/send", props); };
    return MobileBlastAPI;
}(SubAPI));
export { MobileBlastAPI };
